import { AppStateType } from "@pd/redux/store/reducers";
import { createSelector } from "@reduxjs/toolkit";
import {
  TransferDbType,
  UnprocessedPayoutDbType,
} from "@pd/redux/types/dbTypes";
import { ErrorPayload } from "@pd/api/utils/safeFetch";
import { isDashboardState } from "../../../types";

export const selectAllTransfers = createSelector(
  (state: AppStateType) => state,
  (state: AppStateType): TransferDbType[] => {
    if (isDashboardState(state)) {
      const data = state.dashboard.transfers.data.allTransfers;
      if (data) return data;
    }
    return [];
  },
);

export const selectTransfersFetching = createSelector(
  (state: AppStateType) => state,
  (state: AppStateType): boolean => {
    if (isDashboardState(state)) {
      return state.dashboard.transfers.fetching;
    }
    return false;
  },
);
export const selectTransfersError = createSelector(
  (state: AppStateType) => state,
  (state: AppStateType): ErrorPayload => {
    if (isDashboardState(state)) {
      return state.dashboard.transfers.error;
    }
    return {
      message: "",
      status: 0,
    };
  },
);
export const selectTransfersSuccess = createSelector(
  (state: AppStateType) => state,
  (state: AppStateType): boolean => {
    if (isDashboardState(state)) {
      return state.dashboard.transfers.success;
    }
    return false;
  },
);

export const selectUnprocessedPayouts = createSelector(
  (state: AppStateType) => state,
  (state: AppStateType): UnprocessedPayoutDbType[] => {
    if (isDashboardState(state)) {
      return state.dashboard.transfers.data.unprocessedPayouts;
    }
    return [];
  },
);
